import React from 'react';
import Breadcrumbs from '../../elements/Breadcrumbs';
import { CardsContainer } from './Clinics.style';
import SimpleCard from '../../elements/SimpleCard';
import { Skeleton } from '@material-ui/lab';

const Clinics = ({
    isLoading,
    clinicsList,
    handleClickCardClinic,
}) => {

    return (
        <>
            <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: 'Клиника' }]} />
            <CardsContainer>
                {isLoading
                    ? <>
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                    </>
                    : clinicsList.map((item) =>
                        <div
                            onClick={() => handleClickCardClinic(item.buildingId, item.id)}
                            key={item?.id + item?.buildingId}
                        >
                            <SimpleCard label={`${item.name}, ${item.address}`} />
                        </div>
                    )
                }
            </CardsContainer>
        </>
    )
}

export default Clinics;
